export default __webpack_public_path__ + "2f620eef654d5a8cfc74d29706677d13.woff";